import { PageLoading } from "#components/ui/PageLoading.tsx";
import { ChannelsDetails } from "#features/channels/components/ChannelsDetails.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import { Content, Heading, Modal } from "@hopper-ui/components";
import { Suspense, useCallback } from "react";

export const ChannelsModal = () => {
    const { tShared } = useSharedTranslation();
    const isSidePanelOpen = useSidePanelStore(state => state.isSidePanelOpen);
    const closeSidePanel = useSidePanelStore(state => state.closeSidePanel);

    const handleOpenChange = useCallback((isOpen: boolean) => {
        if (!isOpen) {
            closeSidePanel();
        }
    }, [closeSidePanel]);

    return (
        <Modal
            size="sm"
            isOpen={isSidePanelOpen}
            onOpenChange={handleOpenChange}
            className="wai-sidepanel-as-modal wai-scrollbars"
            data-private
        >
            <Heading
                marginLeft="core_160"
                marginBottom="core_240"
                size="md"
            >
                {tShared("knowledgeSources")}
            </Heading>
            <Content
                borderTop="neutral-weak"
                margin="core_0"
                minHeight="core_1280"
            >
                <Suspense fallback={<PageLoading />}>
                    <ChannelsDetails />
                </Suspense>
            </Content>
        </Modal>
    );
};
